// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post } from '../../../../common/api'
import { ATTENDANCE_ADMIN } from '../../../../common/constant'

export const actionAttendanceAdmin = createAsyncThunk('appAttendanceAdmin/actionAttendanceAdmin', async (params, thunkAPI) => {
    return await post(ATTENDANCE_ADMIN, params, thunkAPI)
})

export const appAttendanceAdminSlice = createSlice({
    name: 'appAttendance',
    initialState: {
        //list
        loading: false,
        attendanceAdmin: null
    },
    reducers: {
        //reset or delete Add Insurance Company store data
        resetAttendanceAdminResponse: (state) => {
            state.attendanceAdmin = null
        }
    },
    extraReducers: builder => {
        builder

            //list
            .addCase(actionAttendanceAdmin.pending, (state) => {
                state.loading = true
            })
            .addCase(actionAttendanceAdmin.fulfilled, (state, action) => {
                state.loading = false
                state.attendanceAdmin = action.payload
            })
            .addCase(actionAttendanceAdmin.rejected, (state) => {
                state.loading = false
            })

        //get
        // .addCase(actionGetAttendance.pending, (state) => {
        //     state.loadingGet = true
        // })
        // .addCase(actionGetAttendance.fulfilled, (state, action) => {
        //     state.loadingGet = false
        //     state.getAttendance = action.payload
        // })
        // .addCase(actionGetAttendance.rejected, (state) => {
        //     state.loadingGet = false
        // })
    }
})
export const { resetAttendanceAdminResponse } = appAttendanceAdminSlice.actions

export default appAttendanceAdminSlice.reducer